import type { PlatformShowQueryType } from "@/types/graphql/admin.generated";
import { PlatformDetails } from "../PlatformDetails";

export const PlatformShowComponent: React.ComponentType<{
  editData?: unknown;
  platform?: PlatformShowQueryType["platform"];
}> = ({ platform }) => {
  if (!platform) return <div>Загрузка...</div>;

  return <PlatformDetails platform={platform} />;
};
